<template>
    <gcmcn-layout
        title="CHANNELS"
        custom-class="event-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            :loading="!loaded"
            :disabled="!userIsAtLeastAdmin && !userIsEntityAdmin"
            @click="onCreateChannel"
        >
            Add Channel
        </el-button>
        <ns-loader
            ref="nsLoader"
            :to-load="toLoad"
            :scoped="false"
            @dataFetched="onDataFetched"
        >
            <ns-loader-spinner slot="loader"></ns-loader-spinner>
            <template slot="content">
                <el-row :gutter="26" class="gcmcn-separator" :style="{height: `calc(100vh - ${this.$store.getters.pageHeight}px)`}">
                    <el-col
                        :span="13"
                    >
                        <gcmcn-filters
                            ref="gcmcn-filters"
                            :filter-values="[searchFilter, selectedChannelStatus, selectedEntitiesForFilter]"
                            @reset-filters="resetFilters"
                        >
                            <dropdown
                                name="Status"
                                :list="$store.getters.availableChannelStatus" 
                                itemName="name"
                                itemValue="value"
                                :itemsSelected="selectedChannelStatus"
                                @on-select-item="selectedChannelStatus = $event"
                            ></dropdown>
                            <dropdown
                                name="Entities"
                                :multiple="true"
                                :list="$store.getters.entities"
                                itemName="display_name"
                                itemValue="uid"
                                :itemsSelected="selectedEntitiesForFilter"
                                @on-select-item="onSelectEntity"
                            ></dropdown>
                            <dropdown
                                name="Universes"
                                :multiple="true"
                                :list="filteredUniverses"
                                itemName="display_name"
                                itemValue="uid"
                                :itemsSelected="selectedUniversesForFilter"
                                @on-select-item="onSelectUniverses"
                            ></dropdown>
                            <dropdown
                                name="Events"
                                :multiple="true"
                                :list="filteredEvents"
                                itemName="name"
                                itemValue="uid"
                                :itemsSelected="selectedEventsForFilter"
                                @on-select-item="onSelectEvents"
                            ></dropdown>
                            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                        </gcmcn-filters>
                        <div 
                            v-if="filteredChannels.length > 0"
                            class="channel-list"
                            ref="channelList"
                            :style="{height: `calc(100vh - ${this.usedHeight}px)`}"
                        >
                            <channels-card
                                class="channel-card"
                                :ref="channel.uid.toString()"
                                v-for="channel in filteredChannels"
                                :key="channel.uid"
                                :channel="channel"
                                :events="events"
                                :schedulings="filteredSchedulings(channel)"
                                @click.native="openChannelDetails(channel)"
                                :selected-channel="selectedChannel"
                            >
                            </channels-card>
                        </div>
                        <div v-else class="list-empty">no channel</div>
                    </el-col>
                    <el-col :span="11" class="right-part">
                        <channels-form
                            v-if="displayChannelsFormView"
                            :channel="selectedChannel"
                            :events="events"
                            :min-duration-parameter="durationParameter"
                            @channel-created="channelCreated"
                            @leave-form-view="leaveChannelsFormView"
                        ></channels-form>
                        <programming-form
                            v-else-if="displayProgrammingFormView"
                            @leave-form-view="leaveProgrammingFormView"
                        ></programming-form>
                        <channels-details-tabs
                            v-else-if="displayChannelsDetails"
                            :key="selectedChannel.uid"
                            :channel="selectedChannel"
                            :broadcast-right="broadcastRight"
                            :schedulings="filteredSchedulings(selectedChannel)"
                            :events="events"
                            :min-duration-parameter="durationParameter"
                            @on-update-broadcast-right="onUpdateRights"
                            @on-update-channel="onUpdateChannel"
                            @un-select-channel="unSelectChannel"
                            @on-trigger-refresh="triggerRefresh"
                            @on-channel-stopped="triggerRefresh"
                        >
                        </channels-details-tabs>
                    </el-col>
                </el-row>
            </template>
        </ns-loader>
    </gcmcn-layout>
</template>

<script>
import {
    Dropdown,
    SearchFilter,
    GcmcnFilters,
} from 'gcmcn-common';
import {mapGetters} from 'vuex';
import ChannelsCard from './channels-card.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import ChannelsForm from '@/components/page/Channels/channels-form.vue';
import ChannelsDetailsTabs from '@/components/page/Channels/channels-details-tabs.vue';
import ProgrammingForm from '@/components/page/Channels/programming-form.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';

export default {
    components: {
        GcmcnLayout,
        ChannelsForm,
        ProgrammingForm,
        ChannelsDetailsTabs,
        NsLoader,
        NsLoaderSpinner,
        ChannelsCard,
        Dropdown,
        SearchFilter,
        GcmcnFilters
    },

    name: 'Index',

    data () {
        return {
            displayChannelsFormView: false,
            displayProgrammingFormView: false,
            displayChannelsDetails: false,
            loaded: false,
            selectedChannel: null,
            durationParameter: 0,
            channels: [],
            events: [],
            universes: [],
            broadcastRight: [],
            //filters
            selectedChannelStatus: [],
            searchFilter: '',
            unMutedChannelsUid: [],
            schedulings: [],
            usedHeight: 0,
            resized: false,
        };
    },
    computed:{
        ...mapGetters([
            'windowWidth',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'selectedEntitiesForFilter',
            'selectedUniversesForFilter',
            'selectedEventsForFilter',
        ]),
        toLoad (){
            return [
                {
                    name: 'channels',
                    model: 'channels',
                    filters: {
                        archived: false,
                        ordering: 'display_name',
                        'status!': 'FINISHED',
                    }
                },
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'universes',
                    model: 'universes',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'broadcastRight',
                    model: 'broadcastRight',
                    filters: {
                        feed__isnull: true,
                        archived: false,
                        revoked: false,
                        c_resp_nested: true,
                    }
                },
                {
                    model: 'parameters',
                    name: 'durationParameter',
                    filters:{
                        name: 'MIN_CHANNEL_DURATION_IN_MIN',
                    }
                },
                {
                    name: 'schedulings',
                    model: 'schedulings',
                    filters: {
                        status__in: 'PENDING,RUNNING',
                        ordering: 'start_date',
                        archived: false,
                    }
                },
            ];
        },
        filteredUniverses(){
            if(this.selectedEntitiesForFilter.length > 0){
                let universes = [...this.universes];
                let filteredUniverses = universes.filter(universe=>{
                    return  this.selectedEntitiesForFilter.includes(universe.scopes.entity_uid);

                });
                return filteredUniverses;
            }
            return this.universes;
        },
        filteredEvents(){
            let filteredEvents = [...this.events];
            if(this.selectedEntitiesForFilter.length > 0){
                filteredEvents = filteredEvents.filter(event=>{
                    return  this.selectedEntitiesForFilter.includes(event.scopes.entity_uid);
                });
            }
            if(this.selectedUniversesForFilter.length > 0){
                // returns all event based on universe‡
                filteredEvents = filteredEvents.filter(event=>{
                    return  this.selectedUniversesForFilter.includes(event.universe_uid);
                });
            }
            return filteredEvents;
        },
        filteredChannels (){
            let channels = this.channels.slice();
            if(this.selectedChannelStatus.length > 0){
                channels = channels.filter((channel) => this.selectedChannelStatus.includes(channel.status));
            }
            if(this.selectedEntitiesForFilter.length > 0){
                channels = channels.filter((channel) => this.selectedEntitiesForFilter.includes(channel.scopes.entity_uid));
            }
            if(this.selectedUniversesForFilter.length > 0){
                /*
                    No direct link between channel and universe so we return all feeds based on relation between event and universe
                */
                let eventUids = this.filteredEvents.map(event => event.uid);
                channels = channels.filter((channel) => eventUids.includes(channel.event_uid));
            }
            if(this.selectedEventsForFilter.length > 0){
                channels = channels.filter((channel) => this.selectedEventsForFilter.includes(channel.event_uid));
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                channels = channels.filter((channel) => channel.display_name.toLowerCase().includes(searchFilter) ||
                    this.events.find((ev) => ev.uid === channel.event_uid).name.toLowerCase().includes(searchFilter)
                );
            }
            return channels;
        },
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
        filteredChannels (){
            if(!this.filteredChannels.includes(this.selectedChannel)){
                this.displayChannelsDetails = false;
                this.$set(this, 'selectedChannel', null);
            }
        }
    },
    methods:{
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        resetFilters (){
            this.$set(this, 'selectedChannelStatus', []);
            this.$store.commit('CLEAR_ALL_FILTERS');
            this.$refs.search.clear();
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
        onSelectUniverses (universes){
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', universes);
        },
        onSelectEvents (events){
            this.$store.commit('SET_EVENTS_FOR_FILTER', events);
        },
        onDataFetched (res){
            this.$set(this, 'broadcastRight', res.broadcastRight);
            this.$set(this, 'durationParameter', res.durationParameter[0].data.value);
            this.$set(this, 'schedulings', res.schedulings);
            this.$set(this, 'channels', res.channels.sort((a,b) => {
                if (a.status !== b.status && [a.status, b.status].includes('FINISHED')){
                    return a.status === 'FINISHED' ? 1 : -1;
                }
                return a.display_name.toLowerCase() > b.display_name.toLowerCase() ? 1:-1;
            }));
            this.$set(this, 'events', res.events);
            this.$set(this, 'universes', res.universes);
            if (this.selectedChannel && this.selectedChannel.uid) {
                this.selectedChannel = res.channels.find(channel => channel.uid === this.selectedChannel.uid);
            }
            this.loaded = true;
            if(this.selectedChannel === null && this.$route.params.channelUid){
                const channel = this.channels.find((c) => c.uid === this.$route.params.channelUid);
                this.openChannelDetails(channel);
                this.$nextTick(()=>{
                    this.computeFilterHeight();
                    this.scrollToChannel(channel);
                    delete this.$route.params.channelUid;
                });
                if(this.$route.params.edit){
                    this.onUpdateChannel();
                }
            }
            this.$nextTick(()=>{
                this.computeFilterHeight();
            });
        },
        scrollToChannel(channel){
            let channelRef = channel.uid;
            let item = this.$refs[channelRef][0];
            let element = this.$refs.channelList;
            let top = item.$el.offsetTop;
            this.$nextTick(()=>{
                // 84 === filter height
                element.scrollTop = top - 84;
            });
        },
        onCreateChannel (){
            // this.$set(this, 'selectedProgrammation', null);
            this.selectedChannel = null;
            this.displayChannelsFormView = true;
        },
        selectChannel (channel){
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedChannel', channel);
        },
        unSelectChannel() {
            this.displayChannelsDetails = false;
            this.$set(this, 'selectedChannel', null);
            this.$refs.nsLoader.triggerRefresh();
        },
        onUpdateChannel (){
            this.displayChannelsFormView = true;
        },
        openChannelDetails(channel){
            if(this.displayChannelsFormView){
                this.displayChannelsFormView = false;
            }
            this.selectedChannel = channel;
            this.displayChannelsDetails = true;
        },
        openProgrammingForm(){
            this.displayProgrammingFormView = true;
        },
        channelCreated (channel){
            this.openChannelDetails(channel);
            this.$refs.nsLoader.triggerRefresh();
        },
        leaveChannelsFormView (){
            if(this.displayChannelsDetails && !this.selectedChannel){
                this.displayChannelsDetails = false;
            }
            this.displayChannelsFormView = false;
        },
        leaveProgrammingFormView (){
            this.displayProgrammingFormView = false;
        },
        displayDetails(){
            this.$refs.channelUid.show = true;
        },
        onUpdateRights(){
            this.$refs.nsLoader.triggerRefresh().then(() => {
                this.$eventBus.$emit('broadcast-right-save-ended');
            });
        },
        triggerRefresh(){
            this.$refs.nsLoader.triggerRefresh();
        },
        filteredSchedulings(channel){
            return this.schedulings.filter(scheduling => scheduling.channel_uid === channel.uid);
        }
    },
};
</script>

<style lang="css" scoped>
.right-part{
    height: 100%;
    overflow: auto;
}
.channel-list{
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 5px;
    scroll-behavior: smooth;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/index.vue